module.exports = require('./src')


//////////////////
// WEBPACK FOOTER
// ./node_modules/vueg-history/index.js
// module id = 53vm
// module chunks = 43